import { TrackingFunction } from "./usage-tracking";

// eslint-disable-next-line @typescript-eslint/no-namespace
export declare namespace window {
  const UC_UI: {
    showSecondLayer: () => void;
  };
  const IS24: {
    TEALIUM: {
      tracking: { report: TrackingFunction };
    };
  };
}

export function cookieBanner(): void {
  return window.UC_UI?.showSecondLayer();
}

const isTealiumReportingFunctionAvailable = (): boolean => {
  try {
    return !!window?.IS24?.TEALIUM?.tracking?.report;
  } catch (e) {
    return false;
  }
};

export const tealiumTracker = (): Promise<typeof window.IS24.TEALIUM.tracking.report> => {
  const tealiumRetryInterval = 1000;
  return new Promise((resolve) => {
    const setTrackingFunction = setInterval(() => {
      if (isTealiumReportingFunctionAvailable()) {
        clearInterval(setTrackingFunction);
        resolve(window.IS24.TEALIUM.tracking.report);
      }
    }, tealiumRetryInterval);
  });
};
